import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { LoginComponent } from '../../shared/login/login.component';
import { Router } from '@angular/router';

import { PageContentService, ParameterConfigService } from '../../core/index.service';

@Component({
    selector: 'shared-authentication',
    templateUrl: './authentication.component.html',
    styleUrls: ['./authentication.component.css']
})

export class AuthenticationComponent {
    authentication: Authentication;
    showLoading: boolean;

    constructor(
        private router: Router,
        private pcService: PageContentService,
        private paramConfigService:ParameterConfigService,
        public dialog: MatDialog,
        public dialogRef: MatDialogRef<AuthenticationComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    )
    {
        this.authentication = new Authentication();
        this.authentication.showSignIn = true;

        if (data && data.message) {
            this.authentication.message = data.message;
        }
        else {
            this.authentication.message = data;
        }
    }
    close(): void {
        this.dialogRef.close();
    }

    SignIn() {
        this.dialog.closeAll();
        let dialogRef = this.dialog.open(LoginComponent, {
            disableClose: false,
            panelClass: 'login-modal',
            autoFocus: false,
            data: { message: this.data }
        }); 
    }

    SignUp() {
        this.dialog.closeAll();
        this.pcService.pageContentYN = true;

        if (window.location.href.indexOf("citizen/register") > 0) {
            this.showLoading = false;
            this.pcService.pageContentYN = false;
        }

        let link = ['citizen/register'];
        this.router.navigate(link)
            .then(success => {
                if (success) {
                    this.showLoading = false;
                    this.pcService.pageContentYN = false;
                }
            })
            .catch(err => {
                this.showLoading = false;
                this.pcService.pageContentYN = false;
            });
    }
}

class Authentication {
    constructor() { }
    message: string;
    showSignIn: boolean;
    showSignOut: boolean;
}


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/shared/common/authentication.component.ts